import { logEvent } from "lib/ga";
import { useCallback } from "react";

export const useGAEvent = () => {
  const trackEvent = useCallback(
    (event: string, params: { [key: string]: any }) => {
      logEvent(event, params);
    },
    []
  );

  const GaLoginEvent = () => {
    trackEvent("login", {
      event_category: "Users",
    });
  };

  const GaRegisterEvent = () => {
    trackEvent("sign_up", {
      event_category: "Users",
    });
  };

  const GaCheckoutEvent = () => {
    trackEvent("begin_checkout", {});
  };

  const GaAddToCartEvent = () => {
    trackEvent("add_to_cart", {
      event_category: "Users",
    });
  };

  return { GaAddToCartEvent, GaCheckoutEvent, GaRegisterEvent, GaLoginEvent };
};
